import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { ButtonWrapper, Button } from "./styles/edit-button-styles";

const EditButton = ({ onClickAction, top, right }) => (
  <Fragment>
    <ReactTooltip
      place="bottom"
      type="dark"
      effect="solid"
      aria-haspopup="true"
      id="edit-button-tooltip"
    />
    <ButtonWrapper
      top={top}
      right={right}
      onClick={() => onClickAction()}
      data-tip="Edit"
      data-for="edit-button-tooltip"
    >
      <Button>
        <FontAwesomeIcon icon={faPencilAlt} />
      </Button>
    </ButtonWrapper>
  </Fragment>
);

EditButton.propTypes = {
  onClickAction: PropTypes.func,
  top: PropTypes.number,
  right: PropTypes.number,
};

EditButton.defaultProps = {
  onClickAction: PropTypes.isNull,
  top: PropTypes.isNull,
  right: PropTypes.isNull,
};

export default EditButton;
